
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {sancionStore} from "@/store/sancionStore";
import {salidaStore} from "@/store/salidaStore";
import {materialStore} from "@/store/materialStore";
import {SancionService} from "@/services/SancionService";
import {SalidaService} from "@/services/SalidaService";
import SancionShow from "@/views/sanciones/SancionShow.vue";
import SancionNew from "@/views/sanciones/SancionNew.vue";
import {Alert} from "@/addons/Alert";
import SancionObservar from "@/views/sanciones/observar.vue";
import router from "@/router";

@Component({
  name: "CompraMaterialesIndex",
  components: {SancionObservar, SancionNew, SancionShow},
  //components: {FacturaHistorial}
})
export default class SancionIndex extends Vue {
  private patterns = Pattern;
  search = null
  private sancionStore = sancionStore();
  private salidaStore = salidaStore();
  private materialStore = materialStore();
  private sancionService = SancionService.getInstance();
  private salidaService = SalidaService.getInstance();

  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private sancionSeleccionada: any = null;

  private isObservar = false;



  get sanciones(): any[] {
    return this.sancionStore.sanciones;
  }

  get valesalidas(): any[] {
    return this.salidaStore.valeSalidas;
  }

  get loading(): boolean {
    return this.sancionStore.loading;
  }

  get pagination(): any {
    return this.salidaStore.pagination;
  }

  get showDialogSancion(): boolean {
    return this.salidaStore.showDialogSalida;
  }

  get isNew(): boolean {
    return this.sancionStore.isNew;
  }

  mounted() {
    this.listar();
  }
  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde la sancion')
      return false
    }
    this.salidaService.imprimirCompraMateriales(id);

  }


  imprimirPlan(id:number){
      this.sancionService.imprimirPlan(id);
  }
  listar() {
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      search: this.search,
      page: this.pagination.current_page
    };
    this.salidaService.indexCompraMateriales(data);
    this.salidaStore.valeSalida = [];
    this.salidaStore.valeSalidas = [];
    this.materialStore.materiales = [];
    this.salidaStore.funcionarios = [];
    this.salidaStore.valeSalidaMaterial = [];
    this.salidaStore.newValeSalida = [];
  }

  editar(salida:any){
    router.push({name: 'compraMaterialeslEdit', params: {valeSalidaEdit: salida}})
  }
  openSancion(sancion:any, isNew:boolean) {
    this.sancionSeleccionada = sancion;
    this.sancionStore.showDialogSancion = true;
    this.sancionStore.isNew = isNew;
    this.sancionService.showPlaPagoSancion(sancion);

    const data = {
      sancion: sancion,
      modelo: 'sancion',
    };
    this.sancionService.historial(data);
  }
  openSancionNew(sancion:any, isNew:boolean) {
    this.sancionStore.sancion = []
    this.sancionStore.cliente = []
    this.sancionStore.sancionNueva = [];
    this.sancionStore.cuotas = [];
    this.sancionSeleccionada = {};
    this.sancionStore.isNew = isNew;
    this.sancionStore.showDialogSancion = false;
    console.log("Nuevo" + this.sancionStore.isNew);
    router.push({name: 'compraMaterialesNew'});
  }

  anularSancion(sancion:any) {
    this.sancionSeleccionada = sancion;
    this.isObservar = true;
  }


  darBaja(sancion:any) {
    Alert.confirm(`Eliminar la Sancion al: <br>
                    Cliente: ${sancion.cuenta}`
    ).then(res => {
      const data = {sancionId: sancion.id}
      if (res.isConfirmed) {
        this.sancionService.baja(data);
        this.listar();
      }
    })
  }

  closeSancion() {
    this.sancionStore.showDialogSancion = false;
    this.sancionStore.sancion = []
    this.sancionStore.cliente = []
    this.sancionStore.isNew = false;
  }
}
